export default __webpack_public_path__ + "static/media/faq.2e2525b6.png";